import ErrorsCard from './ErrorsCard';

export default ErrorsCard;
